export const sanitizeString = (str?: string) => {
    if(!str) return "";
    return String(str)?.toLowerCase()?.replaceAll(" ", "");
};